import i18next from 'i18next'
import React from 'react'
import { InView } from 'react-intersection-observer'
import { blockInviewHandler } from '../../../../utils/inview'
import { RootLayout } from '../../rootLayout'
import { DishTeaserLayout } from '../dishTeasers/dishTeasersLayout'
import { DishTeaserData } from '../dishTeasers/dishTeasersState'

export type DishHighlightProps = {
  teaser: DishTeaserData | 'empty' | 'loading' | 'error'
  extraClasses?: string
}

export const DishHighlightLayout = (p: DishHighlightProps) => (
  <InView
    as="section"
    threshold={0}
    triggerOnce={true}
    onChange={(isInView, entry) => blockInviewHandler(isInView, entry.target)}
    className="block block--dish-teasers"
  >
    <header className="block__header">
      <h2 className="block__title title--xs">{i18next.t('home:dishTitle')}</h2>
    </header>

    {p.teaser === 'loading' ? (
      <RootLayout.Loader hasWrapper={true} showText={true} />
    ) : p.teaser === 'error' ? (
      <RootLayout.LoadingFailed
        text={i18next.t('common:loadingFailed', {
          entity: i18next.t('dishes:dishesTitle').toLowerCase(),
        })}
      />
    ) : p.teaser === 'empty' ? (
      <RootLayout.EmptyState
        text={i18next.t('common:emptyState', {
          entity: i18next.t('dishes:dishesTitle').toLowerCase(),
        })}
      />
    ) : (
      <DishTeaserLayout pageKind="home-logged-in" teaser={p.teaser} />
    )}
  </InView>
)
